import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import DateFilter from './filters/dateFilter'

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.is_admin)) {
      if (store.getters.getRole === "Admin") {
        next()
      } else {
        next('/home')
      }
    } else if (to.matched.some(record => record.meta.authenticated)) {
      if (store.getters.getUserLoged !== null && store.getters.getUserLoged !== undefined) {

        next()
      } else {
        next('/loadingPage')
      }

    } else {
      next()
    }
  }
)

export const bus = new Vue();

Vue.filter('dateFilter', DateFilter)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyD7UPQcGjj6vKVnZDuoFJI8Fkv48y9AFYE",
      authDomain: "pon-sportivo-vasco-85c8a.firebaseapp.com",
      databaseURL: "https://pon-sportivo-vasco-85c8a.firebaseio.com",
      projectId: "pon-sportivo-vasco-85c8a",
      storageBucket: "pon-sportivo-vasco-85c8a.appspot.com",
      messagingSenderId: "351226515962",
      appId: "1:351226515962:web:265449f7ff41c6c2"
    })

    firebase.auth().onAuthStateChanged(user => { //esegue l'autologin dell'utente
      if (user) {
        if (user.emailVerified === true) {
          db.collection('utenti').doc(user.uid).get().then((usr) => {
            var authorized = usr.data().autorizzato
            if (authorized === "1") {
              store.dispatch("setAuthorized", "1")
            }else{
              store.dispatch("setAuthorized", "0")
            }
              var signedIn = []
              store.dispatch("setUserLoged").then(() => {
                const user = store.getters.getUserLoged;
                db.collection("utenti").doc(user.uid).get().then((doc) => {
                  store.dispatch('setRole', doc.data().ruolo)
                  db.collection('iscritti').get().then((list) => {
                    list.forEach(element => {
                      if (element.data().id_utente == user.uid) {
                        signedIn.push(element.data().id_corso)
                      }
                    })
                    store.dispatch('setRegisteredCourses', signedIn)
                    router.replace("/home");
                  })
                })
              }).catch(error => {
                bus.$emit("errorOperation", "Errore: problema nel login automatico(" + error + ")");
              })
            
          }).catch(error => {
            bus.$emit("errorOperation", "Errore: problema nel login automatico(" + error + ")");
          })
        }

      } else {
        this.$router.replace("/login");
      }
    })
  }
}).$mount('#app')

export const db = firebase.firestore()